import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { useYouTubeThumbnail } from "hooks/useYouTubeThumbnail"

interface YouTubeThumbnailProps {
  videoId: string
  className?: string
  alt?: string
  loading?: "lazy" | "eager"
  objectFit?: "cover" | "contain" | "fill" | "none" | "scale-down"
}

const YouTubeThumbnail: React.FC<YouTubeThumbnailProps> = ({
  videoId,
  className,
  alt = "",
  loading = "lazy",
  objectFit = "cover",
}) => {
  const imageData = useYouTubeThumbnail(videoId)

  // Return null if no videoId provided
  if (!videoId) {
    return null
  }

  // Fallback to original URL if no processed image is available
  if (!imageData) {
    return (
      <img
        alt={alt}
        src={`https://img.youtube.com/vi/${videoId}/0.jpg`}
        className={className}
        loading={loading}
        style={{ objectFit }}
      />
    )
  }

  return (
    <GatsbyImage
      image={imageData}
      alt={alt}
      className={className}
      loading={loading}
      objectFit={objectFit}
    />
  )
}

export default YouTubeThumbnail
